import ReactMultiSelectCheckBoxes from "react-multiselect-checkboxes";
import "./MultiSelectDropDown.css";

function MultiSelectDropDown({ handleSelection, options, value }) {

  return (
    <div className="multiSelectBase">
      <ReactMultiSelectCheckBoxes placeholderButtonLabel="Fitments" options={options} value={value} onChange={handleSelection} />
    </div>
  );
}

export default MultiSelectDropDown;
